import React, { useContext, useEffect, useState } from "react";

// External components
import Lottie from "react-lottie-segments";

import "./styles.css";

// DATA
import animationData from "./paper-fold.json";
import { MediaQueryContext } from "../MediaQueryContext";
import Loading from "./loading";
let prevSrc;
let timeout;

const AnimatedCard = ({ src }) => {
  const [direction, setDirection] = useState(-1);
  const [loading, setLoading] = useState(true);
  const [speed, setSpeed] = useState(2);
  const mediaQueryContext = useContext(MediaQueryContext);
  const imgLoaded = () => {
    setDirection(1);
    setLoading(false);
  };

  useEffect(() => {
    const image = document.querySelector(".fold-image image")
    console.log(src)

    if (src === "" || src === undefined) {
      prevSrc = src;
      return setDirection(-1);
    }

    if (prevSrc !== src) {
      setLoading(true);
      setDirection(-1);
      if (timeout) {
        image.removeEventListener("load", imgLoaded);
        clearTimeout(timeout)
      }
      timeout = setTimeout(() => {
        image.addEventListener("load", imgLoaded);
        image.setAttribute("href", src);
        timeout = false
      }, 1500);
      prevSrc = src
    }

    // if (src && image !== null) {
    //   if (image.getAttribute("href")) {
    //     clicked = true
    //     setDirection(-1);
    //     image.removeEventListener("load", imgLoaded);
    //     image.addEventListener("load", imgLoaded);
    //     setTimeout(() => {
    //       image.setAttribute("href", src);
    //       clicked = false;
    //     }, 1000);
    //     setSpeed(4);
    //   }
    // }
  }, [src]);

  return (
    <>
      {loading && <div className="card-loading"><Loading /></div>}

      <div className="paper-fold-wrapper">
        <Lottie
          options={{
            loop: false,
            autoplay: true,
            animationData: animationData,
            rendererSettings: {
              preserveAspectRatio: "xMidYMid slice"
            }
          }}
          direction={direction}
          height={mediaQueryContext.isMobile ? '90vw' : '60vh'}
          speed={speed}
          width={mediaQueryContext.isMobile ? '90vw' : '60vh'}
        />
      </div>
    </>
  );
};

export default AnimatedCard;
